import React from "react";
export const patientsList = {
  showPagination: true,
  columns: [
    { Header: "Reference ID", accessor: "referenceid", sortable: false },
    { Header: "Site", accessor: "site", sortable: false },
    { Header: "Scan Date", accessor: "scandate", sortable: false },
    {
      Header: "Preliminary Analysis",
      accessor: "preliminaryanalysispath",
      sortable: false,
    },
    {
      Header: "IP3 Treatment Plan",
      accessor: "treatmentplanpath",
      sortable: false,
    },
  ],
};
export const patientsListChild = {
  showPagination: false,
  columns: [
    { Header: "Reference ID", accessor: "referenceid", sortable: false },
    { Header: "Site", accessor: "site1", sortable: false },
    { Header: "Scan Date", accessor: "scandate", sortable: false },
    {
      Header: "Preliminary Analysis",
      accessor: "preliminaryanalysispath",
      sortable: false,
    },
    {
      Header: "IP3 Treatment Plan",
      accessor: "treatmentplanpath",
      sortable: false,
    },
  ],
};

export const uploadCT = {
  className: "UploadForm",
  fields: [
    {
      type: "heading",
      label: "CT Scan",
    },
    // {
    //   type: "heading",
    //   label:
    //     "Note: The below fields are only captured to assign the InterVapor ID and will not be stored or collected by Uptake Medical.",
    // },
    // {
    //   type: "input",
    //   name: "patientfirstname",
    //   label: "Patient's First Name",
    //   value: "",
    //   required: false,
    // },
    // {
    //   type: "input",
    //   name: "patientlastname",
    //   label: "Patient's Last Name",
    //   value: "",
    //   required: false,
    // },
    {
      type: "input",
      name: "patientinitial",
      label: "Patient’s Initials (First and Last Only)",
      value: "",
      required: true,
      maxLength: 2,
    },
    {
      type: "searchSelect",
      name: "site",
      label: "Site",
      value: null,
      data: "siteOptions",
      independentSearch: "siteconfig",
      required: true,
      endAdormentIcon :(
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13.992"
          height="8"
          viewBox="0 0 13.992 8"
          style={{ fill: "#69BAFE", marginRight: "-16px" }}
        >
          <defs></defs>
          <path
            className="a"
            d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
            transform="translate(-6.188 -11.246)"
          />
        </svg>
      )
    },
    {
      type: "yearPicker",
      name: "birthyear",
      label: "Birth Year",
      value: null,
      required: true,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13.992"
          height="8"
          viewBox="0 0 13.992 8"
          style={{ fill: "#69BAFE" }}
        >
          <defs></defs>
          <path
            className="a"
            d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
            transform="translate(-6.188 -11.246)"
          />
        </svg>
      ),
      max: new Date(),
    },
    {
      type: "content",
      name: "file",
    },
    {
      type: "textarea",
      name: "referenceId",
      label: "Reference ID",
      value: "",
      maxLength: 500,
    },
    {
      type: "textarea",
      name: "comments",
      label: "Comments",
      value: "",
      // required: true,
    },
  ],
  validations: {
    patientinitial: (e) => {
      if (e === "") {
        return {
          valid: false,
          errMsg: "Patient’s initials are mandatory.",
        };
      }
      if (e.length !== 2) {
        return {
          valid: false,
          errMsg: "Patient’s initials must be 2 characters.",
        };
      }
      if (/^[A-z]+$/.test(e) === false) {
        return {
          valid: false,
          errMsg: "Patient’s initials must contain letters only.",
        };
      }
      return {
        valid: true,
      };
    },
    site: (e) => {
      if (!e) {
        return {
          valid: false,
          errMsg: "Site is mandatory.",
        };
      }
      if (!e.siteid) {
        return {
          valid: false,
          errMsg: "Select site from dropdown",
        };
      }
      return {
        valid: true,
      };
    },
    birthyear: (e) => {
      if (!e) {
        return {
          valid: false,
          errMsg: "Birth Year must be 4 characters.",
        };
      }
      if (isNaN(Date.parse(e))) {
        return {
          valid: false,
          errMsg: "Invalid date format",
        };
      }
      if (e < new Date("1900-01-01")) {
        return {
          valid: false,
          errMsg: "Birth year should not be less than 1901.",
        };
      }
      if (e > new Date()) {
        return {
          valid: false,
          errMsg: "Birth year should not be more than current year.",
        };
      }
      return {
        valid: true,
      };
    },
    // comments: (e) => {
    //   if (!e) {
    //     return {
    //       valid: false,
    //       errMsg: "Comments is mandatory.",
    //     };
    //   }
    //   return {
    //     valid: true,
    //   };
    // },
  },
  contentValidation: {
    file: true,
  },
};
